// sanityClient.js
import sanityClient from '@sanity/client';

export default sanityClient({
  projectId: '3sg6ldia', 
  dataset: 'production', 
  useCdn: false,
});
